/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */

import * as React from 'react';
import {
  components as SelectComponents,
  GroupTypeBase,
  OptionTypeBase,
  SingleValueProps,
  StylesConfig,
} from 'react-select';

type OptionType = OptionTypeBase & { label: string; value: string };
type GroupType = GroupTypeBase<OptionType>;

export const labelSelectStyles: StylesConfig<OptionType, boolean, GroupType> = {
  control: (styles, props) => ({
    ...styles,
    backgroundColor: '#F6F7F9',
    padding: '0.6rem 1.2rem 0.6rem 0px',
    borderRadius: '6px',
    borderColor: '#E2E4E9',
    fontWeight: 400,
    fontSize: '1.6rem',
    color: '#131720',
    width: '100%',
  }),
  menu: (styles) => ({
    ...styles,
    borderRadius: '6px',
    width: '100%',
    marginTop: '0.7rem',
    background: '#fff',
    boxShadow: '0px 2px 12px rgba(19, 23, 32, 0.08)',
    padding: '0.6rem 0.6rem',
  }),
  menuList: (styles) => ({
    ...styles,
    padding: '0px',
  }),
  group: (styles) => ({
    ...styles,
    padding: '0 0 0.5rem 0',
  }),
  groupHeading: (styles) => ({
    ...styles,
    fontWeight: 400,
    color: '#878A92',
    fontSize: '14px',
    padding: '0.6rem 0.8rem',
    textTransform: 'none',
  }),
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isDisabled
        ? '#F6F7F9'
        : isSelected
        ? '#EEF1FC'
        : isFocused
        ? '#F6F7F9'
        : 'inherit',
      padding: '0.6rem 0.6rem 0.6rem 0.4rem',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '20px',
      marginBottom: '0.5rem',
      color: isDisabled ? '#ccc' : '#131720',
      cursor: isDisabled ? 'not-allowed' : 'default',
      borderRadius: '6px',
      ':active': {
        ...styles[':active'],
        backgroundColor: '#EEF1FC',
      },
    };
  },
  multiValue: (styles, props) => ({
    ...styles,
    backgroundColor: props.data.color,
    marginRight: '2px',
  }),
  multiValueLabel: (base) => ({ ...base, color: 'black' }),
  multiValueRemove: (styles, props) => ({
    ...styles,
    ':hover': {
      backgroundColor: props.data.color,
    },
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

export const LabelSelectSingleValue:
  | React.ComponentType<SingleValueProps<OptionType, GroupType>>
  | undefined = (props) => (
  <div className="flex items-center text-black rounded py-3 px-6">
    <span style={{ backgroundColor: `${props.data.color}` }}>{props.data.label}</span>
    {/* <button onClick={props.clearValue} className="ml-8">
      <CloseIcon className="text-gray-600 text-xs" />
    </button> */}
  </div>
);

export const LabelSelectOption = (props) => (
  <SelectComponents.Option {...props}>
    <span
      style={{ backgroundColor: `${props.data.color}` }}
      className={`${!props.data.color} text-black rounded py-3 px-6`}
    >
      {props.data.label}
    </span>
  </SelectComponents.Option>
);

export const LabelSelectNoOptions = (props) => (
  <SelectComponents.NoOptionsMessage {...props}>
    Select an option or create one
  </SelectComponents.NoOptionsMessage>
);
